<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card>
          <div slot="header">
            <strong>Thông tin trình chiếu</strong>
          </div>
          <b-form @submit.prevent="save">
            <b-row>
              <b-col>
                <b-form-group
                  label="Kiểu:"
                  label-for="sliderTypes"
                  :label-cols="2"
                  :horizontal="true"
                  label-align="right"
                >
                  <!-- <select2
                    class="no-padding col-10"
                    v-model="slider.sliderType"
                    v-if="sliderTypes.length > 0 && editing"
                    :options="sliderTypes"
                    placeholder="--- Chọn ---"
                  ></select2> -->
                  <label class="col-form-label col-10">
                    {{ slider.sliderTypeName }}
                  </label>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group
                  label="Hình ảnh:"
                  label-for="file"
                  :label-cols="2"
                  :horizontal="true"
                  label-align="right"
                >
                  <b-form-file
                    v-model="slider.file"
                    id="file"
                    v-if="editing"
                    class="col-10 no-padding"
                    accept="image/*"
                    browse-text="Chọn"
                    placeholder="Chọn tệp tải lên..."
                  >
                  </b-form-file>
                  <b-form-invalid-feedback>
                    Trường này không được để trống!
                  </b-form-invalid-feedback>

                  <b-img
                    v-if="!editing"
                    :src="getUrlImage(slider)"
                    :alt="slider.title"
                    class="w300"
                  ></b-img>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-if="!isImage">
              <b-col>
                <b-form-group
                  label="Danh mục slider:"
                  label-for="sliderVideoTypes"
                  :label-cols="2"
                  :horizontal="true"
                  label-align="right"
                >
                  <select2
                    class="no-padding col-10"
                    v-model="slider.sliderVideoTypeId"
                    v-if="editing && sliderVideoTypes.length > 0"
                    :options="sliderVideoTypes"
                    placeholder="--- Chọn ---"
                  ></select2>

                  <label class="col-form-label col-10" v-if="!editing">
                    {{ slider.sliderVideoTypeName }}
                  </label>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row v-if="isImage">
              <b-col>
                <b-form-group
                  label="Tiêu đề:"
                  label-for="title"
                  :label-cols="2"
                  :horizontal="true"
                  label-align="right"
                  :label-class="editing ? 'required' : ''"
                >
                  <b-form-input
                    type="text"
                    id="title"
                    class="col-10"
                    v-if="editing"
                    v-model="$v.slider.title.$model"
                    :state="
                      $v.slider.title.$dirty ? !$v.slider.title.$error : null
                    "
                  >
                  </b-form-input>
                  <b-form-invalid-feedback>
                    Trường này không được để trống!
                  </b-form-invalid-feedback>
                  <label class="col-form-label col-10" v-if="!editing">
                    {{ slider.title }}
                  </label>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row v-if="isImage">
              <b-col>
                <b-form-group
                  label="Mô tả:"
                  label-for="description"
                  :label-cols="2"
                  :horizontal="true"
                  label-align="right"
                  :label-class="editing ? 'required' : ''"
                >
                  <b-form-textarea
                    v-model="$v.slider.description.$model"
                    :state="
                      $v.slider.description.$dirty
                        ? !$v.slider.description.$error
                        : null
                    "
                    v-if="editing"
                    class="col-10"
                    id="description"
                    rows="3"
                  ></b-form-textarea>
                  <b-form-invalid-feedback>
                    Trường này không được để trống!
                  </b-form-invalid-feedback>
                  <label class="col-form-label col-10" v-if="!editing">
                    {{ slider.description }}
                  </label>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row v-if="isImage">
              <b-col>
                <b-form-group
                  label="Đường dẫn:"
                  label-for="link"
                  :label-cols="2"
                  :horizontal="true"
                  label-align="right"
                  :label-class="editing ? 'required' : ''"
                >
                  <b-form-input
                    type="text"
                    id="link"
                    class="col-10"
                    v-if="editing"
                    v-model="$v.slider.link.$model"
                    :state="
                      $v.slider.link.$dirty ? !$v.slider.link.$error : null
                    "
                  >
                  </b-form-input>
                  <b-form-invalid-feedback>
                    Trường này không được để trống!
                  </b-form-invalid-feedback>
                  <label class="col-form-label col-10" v-if="!editing">
                    {{ slider.link }}
                  </label>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-else>
              <b-col>
                <b-form-group
                  label="Đường dẫn:"
                  label-for="urlVideo"
                  :label-cols="2"
                  :horizontal="true"
                  label-align="right"
                  :label-class="editing ? 'required' : ''"
                >
                  <b-form-input
                    type="text"
                    id="urlVideo"
                    class="col-10"
                    v-if="editing"
                    v-model="$v.slider.urlImage.$model"
                    :state="
                      $v.slider.urlImage.$dirty
                        ? !$v.slider.urlImage.$error
                        : null
                    "
                  >
                  </b-form-input>
                  <b-form-invalid-feedback>
                    Trường này không được để trống!
                  </b-form-invalid-feedback>
                  <label class="col-form-label col-10" v-if="!editing">
                    {{ slider.urlImage }}
                  </label>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-if="isImage">
              <b-col>
                <b-form-group
                  label="Nhãn nút ấn:"
                  label-for="labelButton"
                  :label-cols="2"
                  :horizontal="true"
                  label-align="right"
                  :label-class="editing ? 'required' : ''"
                >
                  <b-form-input
                    type="text"
                    id="labelButton"
                    class="col-10"
                    v-if="editing"
                    v-model="$v.slider.labelButton.$model"
                    :state="
                      $v.slider.labelButton.$dirty
                        ? !$v.slider.labelButton.$error
                        : null
                    "
                  >
                  </b-form-input>
                  <b-form-invalid-feedback>
                    Trường này không được để trống!
                  </b-form-invalid-feedback>
                  <label class="col-form-label col-10" v-if="!editing">
                    {{ slider.labelButton }}
                  </label>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group
                  label="Số thứ tự hiển thị:"
                  label-align="right"
                  label-for="description"
                  :label-cols="2"
                  :horizontal="true"
                >
                  <b-form-input
                    type="number"
                    class="col-10"
                    v-if="editing"
                    v-model="slider.displayOrder"
                  >
                  </b-form-input>
                  <label class="col-form-label col-10" v-if="!editing">
                    {{ slider.displayOrder }}
                  </label>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group label="" :label-cols="2">
                  <!--<b-button type="button" variant="primary" @click="edit" v-if="!editing ">Sửa</b-button>-->
                  <b-button
                    type="button"
                    variant="secondary"
                    @click="back"
                    v-if="!editing"
                    >Quay lại</b-button
                  >
                  <b-button
                    type="submit"
                    variant="primary"
                    v-if="editing && authorize(['ManageSlider'])"
                    >Ghi lại</b-button
                  >
                  <b-button
                    type="button"
                    variant="secondary"
                    @click="cancel"
                    v-if="editing"
                    >Hủy</b-button
                  >
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { validationMixin } from "vuelidate";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import { authorizationMixin } from "@/shared/mixins";

export default {
  name: "SliderDetail",
  mixins: [validationMixin, authorizationMixin],
  data() {
    return {
      slider: {
        file: null,
      },
      editing: this.$route.meta.editing,
      sliderTypes: [
        { id: 1, text: "Hình ảnh" },
        { id: 2, text: "Video" },
      ],
    };
  },
  computed: {
    sliderId() {
      return this.$route.params.sliderId;
    },
    isImage() {
      return this.slider.sliderType === "1" || this.slider.sliderType === 1;
    },
    ...mapState({
      sliderVideoTypes: (state, getters) => state.common.sliderVideoTypes,
    }),
  },
  validations: {
    slider: {
      title: {
        requiredIf() {
          return !(this.isImage && !this.slider.title);
        },
      },
      description: {
        requiredIf() {
          return !(this.isImage && !this.slider.description);
        },
      },
      link: {
        requiredIf() {
          return !(this.isImage && !this.slider.link);
        },
      },
      labelButton: {
        requiredIf() {
          return !(this.isImage && !this.slider.labelButton);
        },
      },
      file: {
        requiredIf() {
          return !(this.isImage && !this.slider.file);
        },
      },
      urlImage: {
        requiredIf() {
          return !(!this.isImage && !this.slider.urlImage);
        },
      },
    },
  },
  watch: {},
  created() {
    this.loadSliderDetail();
  },
  methods: {
    loadSliderDetail() {
      var vm = this;
      return this.$services
        .get(`system/sliders/${this.sliderId}`)
        .done((slider) => {
          vm.slider = slider;
        });
    },
    edit() {
      this.editing = true;
    },
    back() {
      this.$router.push({ path: "/system/sliders" });
    },
    cancel() {
      var vm = this;
      this.loadSliderDetail().done(() => (vm.editing = false));
    },
    save() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        var vm = this;
        this.$services.upload(`system/sliders`, this.slider).done(() => {
          vm.$toastr.s("Cập nhật thành công");
          vm.cancel();
        });
      }
    },
    getUrlImage(item) {
      let path = null;
      if(this.isImage){
        path = item.urlImage;
      }
      else{
        path = item.urlThumbnailVideo
      }
      return this.$services.getResourceUrl() + path;
    },
  },
};
</script>
<style>
/*  .ck-editor__editable {
        min-height: 500px;
    }*/
.ck-editor .ck-editor__main .ck-content {
  min-height: 200px;
}

.ck-editor__editable_inline {
  min-height: 200px;
}
</style>
<style scoped>
.wh200 {
  width: 200px;
}

.w300 {
  width: 300px;
}
</style>